import React from 'react'

import { Stack, SxProps, Typography } from '@mui/material'

import { InfoButton } from '../InfoButton'

type WidgetTitlePropTypes = {
  children: string
  explanation?: string | null
  sx?: SxProps
}

export const WidgetSubtitle: React.FC<WidgetTitlePropTypes> = ({ children, explanation, sx }) => {
  return (
    <Stack direction={'row'} spacing={1} alignItems={'flex-start'} sx={sx}>
      <Typography variant="body1" color="text.secondary">
        {children}
      </Typography>

      {Boolean(explanation) && <InfoButton explanation={explanation} />}
    </Stack>
  )
}

export default WidgetSubtitle
